<template>
  <div class="dropdowns-special">
    <div>
      <b-modal ref="dcModalRef" id="deal-catalog-modal" header-bg-variant="info" header-text-variant="white" centered hide-footer no-fade size="lg" title="Deal catalog">
        <deal-catalog :shownTypes="shownTypes" :path="path" :isModal="true"/>
      </b-modal>
    </div>
    <b-card v-if="this.validDeal" no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0 mt-1">
        <b-btn block href="#" v-b-toggle.dealInformation variant="info" class="text-left">{{ this.dealName }} - {{ this.type.toUpperCase() }} Analysis</b-btn>
      </b-card-header>
      <b-collapse id="dealInformation" visible>
        <b-card-body>
          <div>
            <b-row>
              <b-col cols="4">
                <table class="table table-sm color mb-2">
                  <caption class="caption table-caption mb-2">Calculation Settings</caption>

                  <!-- @change='emit("settlementDateChange", settlementDate)' -->
                  <b-form-group label-cols="6" label-cols-lg="4" label="Settlement Date" label-for="input-st-date" class="text-left mb-0">
                    <b-input-group>
                      <datepicker
                        id="input-st-date" :clearable="false"
                        input-class="form-control text-right calculation-settings-input"
                        type="date"
                        format="MM/DD/YYYY"
                        lang="en"
                        v-model="settlementDate"
                        :disabled-date="isDisabledSettlementDate"
                      />
                      <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" disabled>
                        <template slot="button-content"><i class="fas fa-sort-down transparent"></i></template>
                      </b-dropdown>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group label-cols="6" label-cols-lg="4" label="Credit Model" label-for="ppay_model" class="text-left mb-0">
                    <b-input-group>
                      <b-form-select id="ppay_model" v-model="prepaymentModel" @change="onPrepaymentModelChanged">
                        <option :value="null">None</option>
                        <option value="LDM" v-if="this.$store.getters.isLDMUser">LDM 2.2</option>
                        <option value="LDM_3" v-if="this.$store.getters.isLDMUser">LDM 3.0</option>
                        <option value="AFT" v-if="this.$store.getters.isAFTUser">AFT</option>
                      </b-form-select>
                      <b-dropdown variant="link" slot="append" toggle-class="toggle-class" class="no-v-padding" disabled>
                        <template slot="button-content"><i class="fas fa-sort-down transparent"></i></template>
                      </b-dropdown>
                    </b-input-group>
                  </b-form-group>

                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'CPR'"
                    :isDisabled="selectedScenario != null" type="CPR" :model="cpr" id="input-cpr"
                    :vectors="this.vectors" @CPRVectorChange='(data) => { cpr = data; emit("cprChange", data)}'
                    showHeader="true" :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'CDR'"
                    :isDisabled="selectedScenario != null" type="CDR" :model="cdr" id="cdrInput"
                    :vectors="this.vectors" @CDRVectorChange='(data) => { cdr = data; emit("cdrChange", data)}' 
                    showHeader="true" :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'LossSeverity'"
                    :isDisabled="selectedScenario != null" type="LossSeverity" :model="lossSeverity" id="severityInput"
                    :vectors="this.vectors" @LossSeverityVectorChange='(data) => { lossSeverity = data; emit("lossSeverityChange", data)}'
                    showHeader="true" :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == null" :name="'Delinquency'" :unit="null"
                    :isDisabled="selectedScenario != null" type="Delinquency" :model="delinquency" id="dlqInput"
                    :vectors="this.vectors" @DelinquencyVectorChange='(data) => { delinquency = data; emit("delinquencyChange", data)}'
                    showHeader="true" :showDropdown="true"
                  />
                  <!-- LDM LDM_3 -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    :name=" 'HPI'"
                    :isDisabled="selectedScenario != null" type="HPI" :model="hpi" id="input-hpi"
                    :vectors="this.vectors" @HPIVectorChange='(data) => { hpi = data; emit("hpiChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel == 'LDM_3'"
                    :name=" 'Unemployment'"
                    :isDisabled="selectedScenario != null" type="NationalUnemploymentForecast" :model="NationalUnemploymentForecast" id="input-NationalUnemploymentForecast"
                    :vectors="this.vectors" @NationalUnemploymentForecastVectorChange='(data) => { NationalUnemploymentForecast = data; emit("NationalUnemploymentForecastChange", data)}'
                    showHeader="true" :showDropdown="true"
                  />
                  <!-- ADCO -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    name="2Yr TSY"
                    :isDisabled="selectedScenario != null" type="2YrTsy" :model="twoYrTsy" id="2yrtsy"
                    :vectors="this.vectors" @2YrTsyVectorChange='(data) => { twoYrTsy = data; emit("2YrTsyChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    name="10Yr TSY"
                    :isDisabled="selectedScenario != null" type="10YrTsy" :model="tenYrTsy" id="10yrtsy"
                    :vectors="this.vectors" @10YrTsyVectorChange='(data) => { tenYrTsy = data; emit("10YrTsyChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    :name="'Tune CPR'"
                    :unit="''" :isDisabled="selectedScenario != null" type="TuneCpr" :model="tuneCpr" id="tunecpr"
                    :vectors="new Map()" @TuneCprVectorChange='(data) => { tuneCpr = data; emit("tuneCprChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    name="Tune CDR"
                    type="TuneCdr" :model="tuneCdr" :unit="''" :isDisabled="selectedScenario != null"
                    :vectors="new Map()" @TuneCdrVectorChange='(data) => { tuneCdr = data; emit("tuneCdrChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')"
                    name="Tune Severity" type="TuneSeverity"
                    :model="tuneSeverity" :unit="''" :isDisabled="selectedScenario != null" :vectors="new Map()"
                    @TuneSeverityVectorChange='(data) => { tuneSeverity = data; emit("tuneSeverityChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="15Yr MTG"
                    :isDisabled="selectedScenario != null" type="15YrMtg" :model="mtg15" id="mtg15"
                    :vectors="this.vectors" @15YrMtgVectorChange='(data) => { mtg15 = data; emit("mtg15Change", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel && $store.getters.prepaymentModel.includes('LDM')" name="30Yr MTG"
                    :isDisabled="selectedScenario != null" type="30YrMtg" :model="mtg30" id="mtg30"
                    :vectors="this.vectors" @30YrMtgVectorChange='(data) => { mtg30 = data; emit("mtg30Change", data)}' showHeader="true"
                    :showDropdown="true"
                  />

                  <!-- AFT -->
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" :name=" 'HPA'"
                    :isDisabled="selectedScenario != null" type="HPA" :model="hpa" id="input-hpa"
                    :vectors="this.vectors" @HPAVectorChange='(data) => { hpa = data; emit("hpaChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" name="15Yr MTG"
                    :isDisabled="selectedScenario != null" type="15YrMtg" :model="mtg15" id="mtg15"
                    :vectors="this.vectors" @15YrMtgVectorChange='(data) => { mtg15 = data; emit("mtg15Change", data)}' showHeader="true"
                    :showDropdown="true"
                  />
                  <calculation-settings-input
                    v-if="$store.getters.prepaymentModel == 'AFT'" name="30Yr MTG"
                    :isDisabled="selectedScenario != null" type="30YrMtg" :model="mtg30" id="mtg30"
                    :vectors="this.vectors" @30YrMtgVectorChange='(data) => { mtg30 = data; emit("mtg30Change", data)}' showHeader="true"
                    :showDropdown="true"
                  />

                  <!-- LIBOR -->
                  <calculation-settings-input
                    v-if="type != 'acis'" name="Index Rate"
                    :isDisabled="selectedScenario != null && selectedScenario.type == 'cashflow'" type="LIBOR" :model="libor" id="liborInput"
                    :vectors="this.vectors" @LIBORVectorChange='(data) => { libor = data; emit("liborChange", data)}' showHeader="true"
                    :showDropdown="true"
                  />

                  <b-form-group label-cols="6" label-cols-lg="4" label="Scenario" label-for="scenario_select" class="text-left">
                    <b-input-group class="flex-no-wrap">
                      <b-form-input id="scenario_select" class="text-left cursor-pointer" v-model="cSelectedScenarioName" @click="flagModalScenarioPickerVisible = true"
                                    style="font-size: .8em !important;"></b-form-input>
                      <b-btn v-if="cFlagScenarioSelected" variant="link" class="dropdown-toggle toggle-class p-0 ml-1">
                        <i class="fas fa-times" @click="pickerOk(null)" style="font-size: 0.9rem !important; transform: translateY(-2px);"></i>
                      </b-btn>
                      <b-btn v-if="!cFlagScenarioSelected" variant="link" class="dropdown-toggle toggle-class p-0 ml-1">
                        <i class="fas fa-sort-down" @click="flagModalScenarioPickerVisible = true"></i>
                      </b-btn>
                    </b-input-group>
                  </b-form-group>
                  <b-modal
                    v-model="flagModalScenarioPickerVisible"
                    ok-variant="primary"
                    :scrollable="false"
                    :centered="true"
                    :hide-header="true"
                    :hide-footer="true"
                    size="scenarios"
                  >
                    <scenario
                      :flagAsScenarioPicker="true"
                      :pSelectedDealName="type==='acis' ? [parentDealName, dealName, cDealNameFrom].filter(Boolean) : [dealName, parentDealName, cDealNameFrom].filter(Boolean)"
                      @pickerOk="pickerOk"
                      @pickerCancel="flagModalScenarioPickerVisible = false"
                    />
                  </b-modal>

                  <b-form-checkbox
                    v-if="type == 'acis' && cancellationDate"
                    v-model="cancel"
                    :disabled="selectedScenario != null && selectedScenario.type == 'cashflow'"
                    @change="emit('cancellationChange')"
                    class="text-left"
                  >
                    Early Call Option
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="(this.$store.getters.isLDMUser || this.$store.getters.isAFTUser) && type != 'cirt' && !dealName.startsWith('BELL')"
                    v-model="useLoanLevel"
                    :disabled="selectedScenario != null && selectedScenario.type == 'cashflow'"
                    @change="onUseLoanLevelChanged"
                    class="text-left"
                  >
                    Use Loan Level
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="type != 'acis' && type != 'cirt'"
                    v-model="cleanupCall"
                    :disabled="selectedScenario != null && selectedScenario.type == 'cashflow'"
                    @change="onCleanupCallChanged"
                    class="text-left"
                  >
                    Cleanup Call
                  </b-form-checkbox>

                  <b-form-checkbox
                    v-if="this.prepaymentModel != null && !dealName.startsWith('BELL') && $route.path == '/deal_analysis'"
                    v-model="storeScenario"
                    class="text-left"
                  >
                    Store {{ this.prepaymentModel }} scenario
                  </b-form-checkbox>

                  <b-form-checkbox
                   v-if="$store.getters.prepaymentModel"
                   v-model="useMortgageInsurance"
                   class="text-left">
                    Use Mortgage Insurance
                  </b-form-checkbox>

                  <b-form-group
                    v-if="storeScenario && $route.path == '/deal_analysis'"
                    :label-cols="5" label-cols-lg="4" label-size="md" label="Scenario name" label-for="scenarioName"
                  >
                    <b-form-input :disabled="!storeScenario" v-model="newScenarioName" id="scenarioName" class="text-left" size="sm"></b-form-input>
                  </b-form-group>
                </table>
                <b-btn v-if="type == 'deal'" variant="primary" class="float-right" @click="runScenario">Run Scenario</b-btn>
                <b-row>
                  <p v-if="this.$store.getters.isAdmin && this.runTime != 0">Run time: {{ this.runTime }} </p>
                </b-row>
                <b-row>
                  <b-alert v-if="this.inputErrorMsg" variant="danger" class="float-left" show>{{ this.inputErrorMsg }}</b-alert>
                </b-row>
              </b-col>
              <b-col cols="4">
                <b-row class="text-left">
                  <b-col>
                    <table class="table table-sm color no-border">
                      <tbody>
                      <tr>
                        <th class="text-left font-weight-normal">Deal Name:</th>
                        <td class="text-right">
                          <h5 class="mb-0">
                            <a href="#" v-b-modal.deal-catalog-modal class="no-focus" @change='emit("dealNameChange", dealName)'>{{ this.dealName }} </a>
                            <router-link v-if="isOnlineDealsCreationAllowed && this.dealInfo.DealId != null" :to="{path:'deal_create', query: {dealType: this.dealInfo.DealType, dealId : this.dealInfo.DealId}}">
                              <i class="fas fa-edit"/>
                            </router-link>
                            <router-link v-if="isOnlineDealsCreationAllowed" :to="{path:'deal_create', query: {dealType: (this.dealInfo.DealType || 'STACR_ACIS')}}">
                              <i class="fas fa-plus"/>
                            </router-link>
                          </h5>
                          <span v-if="this.parentDealName != ''">
                              <router-link :to="{path:'/deal_analysis', query: {dealName : parentDealName, from: dealName}}">{{ parentDealName }}</router-link>
                            </span>
                          <span v-if="$route.query.from != ''">
                              <router-link :to="{path:'/acis_analysis', query: {dealName : $route.query.from}}">{{ $route.query.from }}</router-link>
                          </span>
                        </td>
                      </tr>
                      <tr v-if="type != 'deal' && type != 'cirt'">
                        <th class="text-left font-weight-normal">Bond Name:</th>
                        <td class="text-right">
                          <select class="form-control custom-select" v-model="bondName" :disabled="bonds.length == 0">
                            <option v-for="bond in bonds" :key=bond.BondName>{{ bond.BondName }}</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left font-weight-normal">Remittance Month:</th>
                        <td>
                          <select class="form-control custom-select" v-model="remittanceDate" :disabled="remittanceDates.length == 0">
                            <option disabled v-for="date in remittanceDates" v-bind:key=date>{{ date }}</option>
                          </select>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col>
                    <deal-information
                      :dealName="this.dealName"
                      :issueDate="this.dealInfo.IssueDate"
                      :factorDate="this.dealInfo.FactorDate"
                      :firstProjectedDate="this.dealInfo.FirstProjectedDate"
                      :maturityDate="this.dealInfo.MaturityDate"
                      :earlyRedemptionPct="this.dealInfo.EarlyRedemptionPct"
                      :earlyRedemptionDate="this.dealInfo.EarlyRedemptionDate"
                    />

                    <div class="text-right mt-3">
                      <b-btn
                        v-if="report1.pLabelRunButton.length > 0"
                        @click="()=>{this.report1_triggerRunReport = !this.report1_triggerRunReport}"
                        variant="primary">{{ report1.pLabelRunButton }}
                      </b-btn>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="4">
                <bond-information
                  v-if="this.type != 'deal' && this.type != 'cirt'"
                  :isAcis="this.type == 'acis'"
                  :originalBalance="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].OriginalBalance : ''"
                  :currentBalance="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].CurrentBalance : ''"
                  :factor="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].Factor : ''"
                  :coupon="this.bonds[this.bondName] != undefined ? this.type == 'acis' ? this.bonds[this.bondName].OriginalCoupon : this.bonds[this.bondName].Coupon : ''"
                  :bondType="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].BondType : ''"
                  :floaterFormula="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].FloaterFormula : ''"
                  :cusip="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].Cusip : ''"
                  :originalEnhance="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].OriginalEnhance : ''"
                  :originalThickness="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].OriginalThickness : ''"
                  :currentEnhance="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].CurrentEnhance : ''"
                  :currentThickness="this.bonds[this.bondName] != undefined ? this.bonds[this.bondName].CurrentThickness : ''"
                />
                <collateral-information
                  v-else
                  :dealName="dealName"
                  :month="collateralMonth"
                  :type="type == 'cirt' ? 'Pool' : 'Collateral'"
                  :originalBalance="this.collateralInfo.OriginalBalance"
                  :currentBalance="this.collateralInfo.CurrentBalance"
                  :dealFactor="this.collateralInfo.DealFactor"
                  :WAC="this.collateralInfo.WAC"
                  :WAM="this.collateralInfo.WAM"
                  :WALA="this.collateralInfo.WALA"
                  :projectedLosses="this.collateralInfo.ProjectedLosses"
                  @downloadCollateral="onDownloadCollateral"
                />
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-3 border-0">
      <b-card-header header-tag="header" class="p-0 mt-1" header-text-variant="white" v-if="report1_reportData.length > 0">
        <b-btn block href="#" v-b-toggle.report1 variant="info" class="text-left">{{ report1.pReportName }}</b-btn>
      </b-card-header>
      <b-collapse id="report1" visible>
        <b-row class="no-gutters">
          <b-col>
            <reportSingleExecutor
              :pReportName="report1.pReportName"
              :pReportParams="report1.pReportParams"
              :triggerRunReport="report1_triggerRunReport"
              :flagShowOwnRunButton="report1.flagShowOwnRunButton"
              :pLabelRunButton="report1.pLabelRunButton"
              @onReportDataReceived="(reportData)=>{this.report1_reportData = reportData; return reportData;}"
            />
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import service                                  from '@/services/HttpRequestService';
import formatter                                from '@/utilities/Formatter';
import {addDealWithScenario, getScenarioByDeal} from '@/utilities/LocalStorageActions';
import moment                                   from 'moment';
import Datepicker                               from 'vue2-datepicker';
import DealCatalog                              from '../dealCatalog';
import CollateralInformation                    from './CollateralInformation';
import BondInformation                          from './BondInformation';
import DealInformation                          from './DealInformation';
import InputTooltip                             from './InputTooltip';
import CalculationSettingsInput                 from './CalculationSettingsInput';
import {
  isBasicAnalysisBodyValid,
  createBasicValidationErrorMessage
}                                               from '@/validators/inputValidator';
import {getFilters, dealAllowed, getDealType}   from '@/utilities/DealTypes';
import RequestBodyFactory                       from "@/services/RequestBodyFactory";
import {TRACE_ERROR}                            from '@/constants';
import reportSingleExecutor                     from "@/components/common/reportSingleExecutor";
import {sortArray}                              from "@/utilities/ArrayUtils";
import scenario                                 from "@/components/scenario";

import { ModelFormatters }                      from "@/models/ModelFormatters";
import { mapGetters }                           from 'vuex';
import Vue from 'vue';

Vue.directive('visible', function(el, binding) {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

export default {
  props:    {
    type:       String,
    shownTypes: Array,
    path:       String,
    filters:    Array,
    inputError: String,
    report1:    {
      type:    Object,
      default: () => {
        return {
          pReportName:          null,
          pReportParams:        [],
          flagShowOwnRunButton: false,
          pLabelRunButton:      ''
          //triggerRunReport:     false, // IN DATA!!!
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      'isOnlineDealsCreationAllowed'
    ]),
    filtersApplied: function () {
      if (this.filters === undefined && this.shownTypes !== undefined) {
        return getFilters(this.shownTypes);
      } else {
        return this.filters;
      }
    },
    collateralMonth() {
      return moment(this.remittanceDate, 'MM/YYYY').format('YYYYMM');
    },
    cProperReportName() {
      const dealName    = this.$route.query.dealName;
      const curDealType = getDealType(dealName);
      return dealName;
    },
    cSelectedScenarioName: function () {
      let res = 'Off';
      if (this.cFlagScenarioSelected) {
        let arr = [this.selectedScenario.data.ScenarioName, this.selectedScenario.data.DealName, this.selectedScenario.data.Vendor];
        arr     = arr.filter(function (e) {
          return e
        });
        res     = arr.join(' / ');
      }
      return res;
    },
    cFlagScenarioSelected: function () {
      return this.selectedScenario && this.selectedScenario.data && this.selectedScenario.data.ScenarioName;
    },
    cDealNameFrom:         function () {
      let res = '';
      if (this.$route && this.$route.query && this.$route.query.from) {
        res = this.$route.query.from;
      }
      return res;
    }
  },
  data() {
    return {
      settlementDate:                 this.$root.$data.settlementDate || new Date(),
      remittanceDate:                 null,
      remittanceDates:                [],
      dealName:                       this.$route.query.dealName,
      parentDealName:                 '',
      dealInfo:                       {},
      bondName:                       this.$store.getters.bondName,
      bondInfo:                       {},
      scenarios:                      [],
      selectedScenario:               null,
      userCollCashflows:              [],
      collateralInfo:                 {},
      cpr:                            [0],
      cdr:                            [0],
      lossSeverity:                   [0],
      delinquency:                    [0],
      hpi:                            [],
      NationalUnemploymentForecast:   [],
      hpa:                            [],
      twoYrTsy:                       [],
      tenYrTsy:                       [],
      tuneCpr:                        [0],
      tuneCdr:                        [0],
      tuneSeverity:                   [0],
      mtg15:                          [0],
      mtg30:                          [0],
      libor:                          [0],
      useMortgageInsurance:           true,
      bonds:                          {},
      inputErrorMsg:                  '',
      validDeal:                      false,
      vectors:                        new Map(),
      cancel:                         false,
      cancellationDate:               '',
      optionalCancellationDateMargin: '',
      useLoanLevel:                   this.$store.getters.useLoanLevel || false,
      storeScenario:                  false,
      tabIndex:                       0,
      newScenarioName:                '',
      prepaymentModel:                this.$store.getters.prepaymentModel,
      runTime:                        0,
      cleanupCall:                    this.$store.getters.cleanupCall || false,
      report1_triggerRunReport:       false,
      report1_reportData:             [],
      flagModalScenarioPickerVisible: false,
    };
  },
  async created() {
    this.$emit('show-spinner');
    this.dealName = this.$route.query.dealName;
    if (dealAllowed(this.dealName, this.filtersApplied)) {
      this.validDeal = true;
      this.$emit('update:validDeal', true);
      await this.populateMainContent();
      if (this.validDeal) {
        //await loadUserCollCashflows(this);
        //await loadScenarios(this);
        //this.selectedScenario = this.populateScenarioByDeal();
      }
      this.setParamsFromUrl();
    }
    this.$emit('hide-spinner');
  },
  async mounted() {
    if (!this.validDeal) {
      this.$refs.dcModalRef.show();
    }
  },
  watch:      {
    inputError(newVal) {
      this.inputErrorMsg = newVal;
    },
    bondName(newVal) {
      // TODO sk: Investigate why it works only when emit is here instead of HTML
      this.$emit('bondNameChange', newVal);
    },
    async settlementDate(newSettlementDate, prevSettlementDate) {
      await this.setNewSettlementDate(newSettlementDate);

      this.$root.$data.setSettlementDate(newSettlementDate);
      this.$emit('settlementDateChange', newSettlementDate);
    }
  },
  methods:    {
    populateScenarioByDeal() {
      const populatedScenario = getScenarioByDeal(this.dealName);
      return populatedScenario && populatedScenario.data ? populatedScenario : null;
    },
    setParamsFromUrl() {
      const urlParamsToThisPropDict = {
        loss_severity: 'lossSeverity',
        delinquency:   'delinquency',
        libor:         'libor'
      };
      for (let urlParam in urlParamsToThisPropDict) {
        let queryParamValue = this.$route.query[urlParam];
        let thisProp        = urlParamsToThisPropDict[urlParam];
        if (queryParamValue) {
          this[thisProp] = queryParamValue;
          this.emit(thisProp + 'Change', queryParamValue);
        }
      }
      let urlSettlementDate = this.$route.query.settle_dt;
      if (urlSettlementDate) {
        this.settlementDate = moment(urlSettlementDate, 'YYYY-MM-DD').toDate();
      }
    },
    async populateMainContent() {
      this.$store.commit('setLastDeal', this.dealName);
      if (this.dealName.startsWith('ACIS')) {
        this.$cookies.set('lastAcisDeal', this.dealName, '1d');
      } else {
        this.$cookies.set('lastBondDeal', this.dealName, '1d');
      }
      readCookies(this);
      let res = {};
      try {
        res = await service.getUserVectors();
        if (res.status == 200) {
          const newVectors = new Map();
          for (let vector of res.data) {
            newVectors.set(vector.Name, vector.Value.join(','));
          }
          this.vectors = newVectors;
        }
        if (this.dealName == '') {
          await service.log(TRACE_ERROR, 'Deal file could not be opened', '');
          throw {response: {data: 'Deal file could not be opened'}};
        } else {
          let queryParameter = this.type == 'acis' ? '?type=acis' : '';
          res                = await service.get('deals/' + this.dealName + queryParameter);
          if (this.type == 'acis') {
            this.parentDealName = res.data.ParentDealName;
            if (
              res.data.Bonds.map(elem => elem.BondName == this.$route.query.bondName).includes(
                true
              ) ||
              res.data.Bonds.map(elem => elem.BondName == this.$store.getters.bondName).includes(
                true
              )
            ) {
              this.bondName = this.$route.query.bondName || this.$store.getters.bondName;
            } else if (res.data.Bonds.length > 0) {
              this.bondName = res.data.Bonds[0]['BondName'];
            }
          } else {
            if (
              res.data.Bonds.map(elem => elem.BondName == this.$route.query.bondName).includes(
                true
              ) ||
              res.data.Bonds.map(elem => elem.BondName == this.$store.getters.bondName).includes(
                true
              )
            ) {
              this.bondName = this.$route.query.bondName || this.$store.getters.bondName;
            } else if (res.data.Bonds.length > 0) {
              this.bondName = res.data.Bonds[0]['BondName'];
            }
          }
          this.$store.commit('setDealName', this.dealName);
          this.$store.commit('setBondName', this.bondName);
          this.setDealData(res.data);
          this.remittanceDate = this.remittanceDates.length > 0 ? this.remittanceDates[0] : null;

          // Settlement date cannot be older than deal info's issue date
          if (this.settlementDate < this.dealInfo.IssueDate$) {
            this.settlementDate = this.dealInfo.IssueDate$;
          }

          await this.setNewSettlementDate(this.settlementDate);
          this.emitDefaultInputs();
        }
      } catch (err) {
        let res = err?.response;
        let msg = res?.data?.Message || res?.data;
        if (msg?.match(/Deal file .* could not be opened/g)) {
          if (this.dealName) {
            msg = 'Could not open deal: ' + this.dealName;
          } else {
            msg = 'Wrong path';
          }
        }
        await service.log(TRACE_ERROR, msg, err.stack);
        await this.$router.push({
          path:  'error',
          query: {status: res?.status, reason: res?.statusText, msg: msg}
        });
      }
    },
    emitDefaultInputs() {
      this.emit('dealNameChange', this.dealName);
      this.emit('bondNameChange', this.bondName);
      this.emit('settlementDateChange', this.settlementDate);
      this.emit('cprChange', this.cpr);
      this.emit('cdrChange', this.cdr);
      this.emit('lossSeverityChange', this.lossSeverity);
      this.emit('delinquencyChange', this.delinquency);
      this.emit('liborChange', this.libor);
    },
    emit(message, value = '') {
      this.$emit(message, value);
    },
    setDealData(data) {
      const { IssueDate: issueDateRawValue, FirstPaymentDate: firstPaymentDateRawValue } = data;
      let issueDate = null;
      let firstPaymentDate = null;
      if (issueDateRawValue != null) {
        issueDate = (ModelFormatters.ToUserData.NumberAsDate())(null, issueDateRawValue);
      }
      if (firstPaymentDateRawValue != null) {
        firstPaymentDate = (ModelFormatters.ToUserData.NumberAsDate())(null, firstPaymentDateRawValue)
      }

      if (this.type == 'acis' && data.OptionalCancellationDate) {
        this.cancellationDate = formatter.formatDateValue(
          (this.optionalCancellationDateMargin = moment(data.OptionalCancellationDate, 'YYYYMMDD')),
          'MM/DD/YYYY'
        );
        this.emit('cancellationDateChange', this.cancellationDate);
      }
      data                       = formatter.formatDollarValues(data, [
        'CollateralOriginalBalance',
        'CollateralCurrentBalance'
      ]);
      data                       = formatter.formatDateValues(data, [
        'SettlementDate',
        'IssueDate',
        'FirstProjectedDate',
        'MaturityDate',
        'EarlyRedemptionDate'
      ]);
      data['EarlyRedemptionPct'] = formatter.formatPctValue(data['EarlyRedemptionPct'], 2);
      data.FactorDate            = formatter.formatDateValue(data.FactorDate, 'MM/DD/YYYY');
      data                       = formatter.formatPctValues(data, ['Wac']);
      data['DealFactor']         = formatter.round(data['DealFactor']);
      data['Wam']                = formatter.round(data['Wam'], 0);
      data['Wala']               = formatter.round(data['Wala'], 0);
      this.remittanceDates       = [];
      for (var date of data.DatesOfAvailableUpdates) {
        this.remittanceDates.push(formatter.formatDateValue(date, 'MM/YYYY'));
      }
      for (var bond of data.Bonds) {
        bond                         = formatter.formatDollarValues(bond, ['OriginalBalance', 'CurrentBalance']);
        bond['Factor']               = formatter.round(bond['Factor']);
        bond['Coupon']               = formatter.formatPctValue(bond['Coupon']);
        bond['OriginalCoupon']       = formatter.formatPctValue(bond['OriginalCoupon']);
        bond['FloaterFormula']       = formatter.formatDashesIfNeeded(bond['FloaterFormula']);
        bond['FloaterFormula']       = bond['FloaterFormula'].replace('LIBOR', 'SOFR');
        bond['OriginalThickness']    =
          bond['OriginalThickness'] != null
            ? formatter.formatPctValue(bond['OriginalThickness'])
            : '-----';
        bond['CurrentThickness']     =
          bond['CurrentThickness'] != null
            ? formatter.formatPctValue(bond['CurrentThickness'])
            : '-----';
        bond['OriginalEnhance']      =
          bond['OriginalEnhance'] != null
            ? formatter.formatPctValue(bond['OriginalEnhance'])
            : '-----';
        bond['CurrentEnhance']       =
          bond['CurrentEnhance'] != null
            ? formatter.formatPctValue(bond['CurrentEnhance'])
            : '-----';
        this.bonds[bond['BondName']] = bond;
      }
      this.dealInfo       = {
        DealId:             data.DealId,
        DealType:           data.DealType,
        SettlementDate:     data.SettlementDate,
        IssueDate:          data.IssueDate,
        IssueDate$:         issueDate,
        FactorDate:         data.FactorDate,
        FirstProjectedDate: data.FirstProjectedDate,
        FirstPaymentDate:   data.FirstPaymentDate,
        FirstPaymentDate$:  firstPaymentDate,
        MaturityDate:       data.MaturityDate,
        EarlyRedemptionPct: data.EarlyRedemptionPct,
        EarlyRedemptionDate:
                            data.EarlyRedemptionDate != '01/01/0000' ? data.EarlyRedemptionDate : '-----'
      };
      this.collateralInfo = {
        OriginalBalance: data.CollateralOriginalBalance,
        CurrentBalance:  data.CollateralCurrentBalance,
        DealFactor:      data.DealFactor,
        WAC:             data.Wac,
        WAM:             data.Wam,
        WALA:            data.Wala,
        ProjectedLosses: this.$store.getters.dealCashflow.collateralInfo.ProjectedLosses
      };
      data.Bonds.forEach(element => {
        this.bonds[element['BondName']]                = element;
        this.bonds[element['BondName']].FloaterFormula = formatter.formatDashesIfNeeded(
          element['FloaterFormula']
        );
      });
      this.$emit('deal-fetched', this.bonds);
    },
    async runScenario() {
      this.inputErrorMsg = '';
      try {
        this.$emit('show-spinner');
        this.setCookies();
        let body = new RequestBodyFactory('BASE', {
          dealName:                     this.dealName,
          settlementDate:               this.settlementDate,
          libor:                        this.libor,
          runLoanLevel:                 this.$store.getters.useLoanLevel,
          prepaymentModel:              this.prepaymentModel,
          cpr:                          this.cpr,
          cdr:                          this.cdr,
          lossSeverity:                 this.lossSeverity,
          delinquency:                  this.delinquency,
          hpi:                          this.hpi,
          NationalUnemploymentForecast: this.NationalUnemploymentForecast,
          hpa:                          this.hpa,
          twoYrTsy:                     this.twoYrTsy,
          tenYrTsy:                     this.tenYrTsy,
          tuneCpr:                      this.tuneCpr,
          tuneCdr:                      this.tuneCdr,
          tuneSeverity:                 this.tuneSeverity,
          mtg15:                        this.mtg15,
          mtg30:                        this.mtg30,
          selectedScenario:             this.selectedScenario,
          cleanupCall:                  this.$store.getters.cleanupCall,
          useMortgageInsurance:         this.useMortgageInsurance
        });
        if (body.PrepaymentModel == 'UserDefined' && !isBasicAnalysisBodyValid(body)) {
          this.inputErrorMsg = createBasicValidationErrorMessage(
            body.Cpr,
            body.Cdr,
            body.LossSeverity,
            body.Delinquency,
            body.Libor
          );
          return;
        }
        if (this.storeScenario && this.newScenarioName == '') {
          this.inputErrorMsg = 'Please provide the scenario\'s name';
          return;
        }
        let start               = Date.now();
        const simulationOptions = {
          storeScenario: this.storeScenario,
          scenarioName: this.newScenarioName
        };
        let res                 = await service.runSimulation(body, simulationOptions);
        let millis              = Date.now() - start;
        let runTime             = Math.floor(millis / 1000);
        let hrs                 = ~~(runTime / 3600);
        let mins                = ~~((runTime % 3600) / 60);
        let secs                = ~~runTime % 60;
        // Output like "1:01" or "4:03:59" or "123:03:59"
        let ret                 = '';
        if (hrs > 0) {
          ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
        }
        ret += '' + mins + ':' + (secs < 10 ? '0' : '');
        ret += '' + secs;
        this.runTime                        = ret;
        let cashflows                       = formatData(res.data);
        let bondItems                       = this.bonds;
        this.collateralInfo.ProjectedLosses = cashflows.ProjectedLosses;
        this.$forceUpdate();
        cashflows.BondsCashflows.forEach(element => {
          bondItems[element['BondName']].Wal             =
            element['Wal'] != null ? formatter.round(element['Wal']) : '-----';
          bondItems[element['BondName']].PrincipalWindow = formatter.formatDashesIfNeeded(
            element['PrincipalWindow']
          );
          bondItems[element['BondName']].WritedownPct    =
            element['WritedownPct'] != null
              ? formatter.formatPctValue(element['WritedownPct'])
              : '-----';
        });
        this.bonds = Object.assign({}, this.bonds, bondItems);
        this.$emit('cashflow-generated', {
          cashflows:      cashflows,
          collateralInfo: this.collateralInfo,
          bonds:          this.bonds,
          runDate:        new Date(),
          miscVariables:  res.data.MiscVariables
        });
      } catch (err) {
        let errRes         = err.response;
        this.inputErrorMsg = errRes.data.Message || errRes.data;
        await service.log(TRACE_ERROR, this.inputErrorMsg, err.stack);
      } finally {
        this.$emit('hide-spinner');
      }
    },
    changeDeal(dealName) {
      this.dealName = dealName;
    },
    onUseLoanLevelChanged() {
      this.$store.commit('useLoanLevelChanged', this.useLoanLevel);
    },
    onCleanupCallChanged() {
      this.$store.commit('useCleanupCall', this.cleanupCall);
    },
    onPrepaymentModelChanged() {
      this.selectedScenario = null;
      this.$emit('scenarioChange', null);
      this.$store.commit('prepaymentModelChanged', this.prepaymentModel);
    },
    clearSimulationResults() {
      this.collateralInfo.ProjectedLosses = '';
      let bondItems                       = this.bonds;
      this.$forceUpdate();
      Object.keys(this.bonds).forEach(bondName => {
        bondItems[bondName].Wal             = '';
        bondItems[bondName].PrincipalWindow = '';
        bondItems[bondName].WritedownPct    = '';
      });
      this.bonds = Object.assign({}, this.bonds, bondItems);
      this.$emit('cashflow-generated', {
        cashflows:      {
          CollateralCashflow: [],
          BondsCashflows:     []
        },
        collateralInfo: this.collateralInfo,
        bonds:          this.bonds
      });
      this.runTime = 0;
    },
    onScenarioChanged(scenario) {
      if (scenario != null) {
        this.prepaymentModel = null;
        this.$store.commit('prepaymentModelChanged', null);
        this.$forceUpdate();
        if (scenario.type == 'cashflow') {
          this.useLoanLevel = false;
        }
        this.$store.commit('useLoanLevelChanged', false);
        this.cleanupCall = false;
        this.$store.commit('useCleanupCall', false);
      }
      this.$emit('scenarioChange', scenario);
      addDealWithScenario(this.dealName, scenario);
      this.clearSimulationResults();
    },
    pickerOk(objScenario) {
      this.selectedScenario = null;
      if (objScenario) {
        this.selectedScenario = {
          type: 'scenario',
          data: objScenario
        };
      }
      this.onScenarioChanged(this.selectedScenario)
      this.flagModalScenarioPickerVisible = false;
    },
    async onDownloadCollateral(dealName, month) {
      let res            = null;
      this.inputErrorMsg = '';
      try {
        res                = await service.getCollateralDataUrl(dealName, month);
        let newWindow      = window.open();
        newWindow.location = res.data;
        setTimeout(function () {
          newWindow.close();
        }, 2500);
      } catch (err) {
        this.inputErrorMsg = 'Collateral data for ' + dealName + ' was not found for ' + month;
        await service.log(TRACE_ERROR, this.inputErrorMsg, err.stack);
      }
    },
    setCookies() {
      let type = this.type;
      this.setCookie('cpr', type + 'Cpr');
      this.setCookie('cdr', type + 'Cdr');
      this.setCookie('lossSeverity', type + 'Severity');
      this.setCookie('delinquency', type + 'Delinquency');
      this.setCookie('libor', type + 'Libor');
      this.setCookie('hpi', type + 'Hpi');
      this.setCookie('NationalUnemploymentForecast', type + 'NationalUnemploymentForecast');
      this.setCookie('hpa', type + 'Hpa');
      this.setCookie('twoYrTsy', type + '2YrTsy');
      this.setCookie('tenYrTsy', type + '10YrTsy');
      this.setCookie('tuneCpr', type + 'TuneCpr');
      this.setCookie('tuneCdr', type + 'TuneCdr');
      this.setCookie('tuneSeverity', type + 'TuneSeverity');
      this.setCookie('mtg15', type + '15YrMtg');
      this.setCookie('mtg30', type + '30YrMtg');
    },
    setCookie(field, cookieName) {
      if (typeof this[field] === 'object') {
        this.$cookies.set(cookieName, JSON.stringify(this[field]), '10d');
      } else if (this[field].length) {
        this.$cookies.set(cookieName, this[field], '10d');
      }
    },
    isDisabledSettlementDate(date) {
      return date < this.dealInfo.IssueDate$;
    },
    async setNewSettlementDate(newSettlementDate) {
      const mmIssueDate = moment(this.dealInfo.IssueDate$);
      let mmSettlementDate = moment(newSettlementDate);
      if (mmSettlementDate <= mmIssueDate) {
        mmSettlementDate = mmIssueDate.add(1, 'month');
      }
      const mmFirstPaymentDate = moment(this.dealInfo.FirstPaymentDate$);
      const rmDateMoment = moment()
        .year(mmSettlementDate.year())
        .month(mmSettlementDate.date() < mmFirstPaymentDate.date() ? mmSettlementDate.month() - 1 : mmSettlementDate.month())
        .date(1);

      const rmDateFormatted = formatter.formatDateValue(rmDateMoment, 'MM/YYYY');
      if (this.remittanceDates.includes(rmDateFormatted)) {
        this.remittanceDate = rmDateFormatted;
      } else if (this.remittanceDates.length > 0 && rmDateMoment.isAfter(moment(this.remittanceDates[0], 'YYYYMMDD'))) {
        this.remittanceDate = this.remittanceDates[0];
      }

      try {
        const { data } = await service.getDealDetails(this.dealName, mmSettlementDate.format('YYYYMMDD'));
        this.setDealData(data);
        await loadUserCollCashflows(this);
      } catch (err) {
        const { message: exceptionMessage, response: { data: { Message: payloadErrorMessage } = {} } = {} } = err;
        this.inputErrorMsg = payloadErrorMessage ?? exceptionMessage;
      }
    }
  },
  components: {
    Datepicker,
    DealCatalog,
    CollateralInformation,
    BondInformation,
    DealInformation,
    InputTooltip,
    CalculationSettingsInput,
    reportSingleExecutor,
    scenario
  }
};

function formatData(data) {
  data.ProjectedLosses = formatter.formatDollarValue(data.ProjectedLosses);
  for (let i = 0; i < data.CollateralCashflow.length; i++) {
    data.CollateralCashflow[i] = formatter.formatDateValues(data.CollateralCashflow[i], [
      'PaymentDate'
    ]);
    data.CollateralCashflow[i] = formatter.formatDollarValues(data.CollateralCashflow[i], [
      'Balance',
      'Interest',
      'PassThru',
      'ScheduledPrincipal',
      'PrepaidPrincipal',
      'Defaults',
      'Losses',
      'Recoveries',
      'CumulativeLosses',
      'CumulativeDefaults'
    ]);
    data.CollateralCashflow[i] = formatter.formatPctValues(data.CollateralCashflow[i], [
      'InterestRate',
      'PassThruRate',
      'CprRate',
      'CdrRate',
      'LossSeverityRate',
      'DelinquencyRate'
    ]);
    if (i > 0 && data.CollateralCashflow[i - 1]['Balance'] < 0.005) {
      data.CollateralCashflow = data.CollateralCashflow.slice(0, i);
      break;
    }
  }
  for (let bondCashflow of data.BondsCashflows) {
    // bondCashflow["Wal"] = formatter.round(bondCashflow["Wal"]);
    // bondCashflow["WritedownPct"] = formatter.formatPctValue(bondCashflow["WritedownPct"]);
    for (let i = 0; i < bondCashflow.BondCashflow.length; i++) {
      bondCashflow.BondCashflow[i] = formatter.formatDateValues(bondCashflow.BondCashflow[i], [
        'PaymentDate'
      ]);
      bondCashflow.BondCashflow[i] = formatter.formatDollarValues(bondCashflow.BondCashflow[i], [
        'Balance',
        'Principal',
        'Interest',
        'Cash',
        'ActualWriteDown'
      ]);
      bondCashflow.BondCashflow[i] = formatter.formatPctValues(bondCashflow.BondCashflow[i], [
        'Rate',
        'CprRate',
        'CdrRate',
        'LossSeverityRate',
        'DelinquencyRate'
      ]);
      if (i > 0 && bondCashflow.BondCashflow[i - 1]['Balance'] < 0.005) {
        bondCashflow.BondCashflow = bondCashflow.BondCashflow.slice(0, i);
        break;
      }
    }
  }
  return data;
}

async function loadScenarios(root) {
  root.scenarios     = [];
  let dealName       = root.dealName;
  let parentDealName = root.parentDealName;
  let results        = [];
  try {
    let res = await service.getUserScenarios(dealName);
    if (res.status == 200) {
      results = results.concat(res.data);
    }
  } catch (err) {
    await service.log(TRACE_ERROR, 'Error occurred get user scenarios', err.stack);
  }
  try {
    if (parentDealName != '') {
      let res = await service.getUserScenarios(parentDealName);
      if (res.status == 200) {
        results = results.concat(res.data);
      }
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, 'Error occurred get user scenarios', err.stack);
    }
  }
  try {
    let res = await service.getUserScenarios('Default');
    if (res.status == 200) {
      results = results.concat(res.data);
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, err.response.data, err.stack);
    }
  }
  if (results.length > 0) {
    let filteredScenarios = results.filter(
      s =>
        s.DealName == '' ||
        s.DealName == dealName ||
        (parentDealName != '' && s.DealName == parentDealName)
    );
    for (let scenario of filteredScenarios) {
      let text = scenario.ScenarioName;
      text +=
        scenario.Vendor == undefined || scenario.Vendor == '' ? '' : ' from ' + scenario.Vendor;
      text +=
        scenario.DealName == undefined || scenario.DealName == ''
          ? ''
          : ' specific for ' + scenario.DealName;
      root.scenarios.push({
        text:  text,
        value: {
          type: 'scenario',
          data: scenario
        }
      });
      root.scenarios = sortArray(root.scenarios, true, 'text');
    }
  }
}

async function loadUserCollCashflows(root) {
  root.userCollCashflows = [];
  try {
    let res = await service.getUserCollateralCashflows(
      root.dealName,
      null,
      formatter.formatAsYYYYMM(root.settlementDate)
    );
    if (res.status == 200) {
      for (let userCashflow of res.data) {
        root.userCollCashflows.push({
          text:  userCashflow.ScenarioName,
          value: {
            type: 'cashflow',
            data: userCashflow
          }
        });
      }
    }
  } catch (err) {
    if (err.response.status != 404) {
      root.inputErrorMsg = err.response.data;
      await service.log(TRACE_ERROR, err.response.data, err.stack);
    }
  }
}

function readCookies(root) {
  let type = root.type;
  readCookie(root, 'cpr', type + 'Cpr', 10);
  readCookie(root, 'cdr', type + 'Cdr', 0.5);
  readCookie(root, 'lossSeverity', type + 'Severity', 20);
  readCookie(root, 'delinquency', type + 'Delinquency');
  readCookie(root, 'hpi', type + 'Hpi', '');
  readCookie(root, 'NationalUnemploymentForecast', type + 'NationalUnemploymentForecast', '');
  readCookie(root, 'hpa', type + 'Hpa', '');
  readCookie(root, 'twoYrTsy', type + '2YrTsy', '');
  readCookie(root, 'tenYrTsy', type + '10YrTsy', '');
  readCookie(root, 'tuneCpr', type + 'TuneCpr', 1);
  readCookie(root, 'tuneCdr', type + 'TuneCdr', 1);
  readCookie(root, 'tuneSeverity', type + 'TuneSeverity', 1);
  readCookie(root, 'libor', type + 'Libor');
  readCookie(root, 'mtg15', type + '15YrMtg', '');
  readCookie(root, 'mtg30', type + '30YrMtg', '');
}

function readCookie(root, field, cookieName, defaultValue = 0) {
  let cookie = [defaultValue];
  if (root.$cookies.isKey(cookieName)) {
    cookie = root.$cookies.get(cookieName);
    try {
      let parsedCookie = JSON.parse(cookie);
      if (typeof parsedCookie === 'object') {
        cookie = parsedCookie;
      }
    } catch (err) {
    }
  }
  root[field] = cookie;
  root.emit(field + 'Change', cookie);
}
</script>

<style lang="scss" scoped>
table {
  &.color {
    margin-bottom: 0;

    th {
      vertical-align: middle;
    }
  }

  &.no-border {
    th,
    td {
      border: none;
    }
  }
}

.form-control {
  font-size: 0.9rem;
  text-align: right;
}

.no-focus {
  &:focus {
    outline: none;
  }
}
</style>
